<template>
    <div class="modal fade show" id="sleepData" tabindex="-1" role="dialog" aria-labelledby="sleepData" aria-hidden="true" style="display: block;">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel">Sleep Timing</h4>
                    <button type="button" class="close" @click.prevent="$parent.toggleForm()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <loader v-if="pageLoader"></loader>
                    <div class="Sleep_input">
                        <p>Sleep Start Timing</p>
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="form-group field-wrapper">
                                <input class="float-field form-control" type="date" name="Sleep Start Date" v-model="sleepStartDate" v-validate="'required'" :max="disableFuture" v-if="from == ''">
                                <input class="float-field form-control" type="date" name="Sleep Start Date" v-model="sleepStartDate" v-validate="'required'"  :min="MinTodayDate" :max="disableFuture" v-else-if="from == 'daily-task' && $parent.filter == 'today'">
                                <input class="float-field form-control" type="date" name="Sleep Start Date" v-model="sleepStartDate" v-validate="'required'"  :min="MinYesDate" :max="MinTodayDate" v-else-if="from == 'daily-task' && $parent.filter == 'yesterday'">
                                <p class="error" v-if="submitted && errors.has('Sleep Start Date')">Sleep Start Date is required</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input class="float-field form-control" type="time" name="Sleep Start Time" v-model="sleepStartTime" v-validate="'required'" min="00:00" :max="disableFutureTime">
                                <p class="error" v-if="submitted && errors.has('Sleep Start Time')">Sleep Start Time is required</p>
                            </div>
                        </div>
                    </div>
                    <div class="Sleep_input">
                        <p>Sleep End Timing</p>
                        <div class="d-flex align-items-center justify-content-between">
                            <div class="form-group field-wrapper" v-if="from != 'daily-task'">
                                <input class="float-field form-control" type="date" name="Sleep End Date" v-model="sleepEndDate" v-validate="'required'" :max="disableFuture" :min="sleepStartDate">
                                <p class="error" v-if="submitted && errors.has('Sleep End Date')">Sleep End Date is required</p>
                            </div>
                            <div class="form-group field-wrapper">
                                <input class="float-field form-control" type="time" name="Sleep End Time" v-model="sleepEndTime" v-validate="'required'" :max="disableFutureTime" :min="sleepStartTime">
                                <p class="error" v-if="submitted && errors.has('Sleep End Time')">Sleep End Time is required</p>
                            </div>
                        </div>
                    </div>
                    <p class="error" v-if="showError">Sleep Start Time shuld be before Sleep End Time</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default red" data-dismiss="modal" @click.prevent="$parent.toggleForm()">Close</button>
                    <button type="button" class="btn btn-default btn-blue" @click.prevent="SaveSleepData()">Save changes</button>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    export default {
        name: "Sleep-form",
        data() {
            return {
                pageLoader : false,
                submitted : false,
                sleepStartDate:'',
                sleepStartTime: '',
                sleepEndDate:'',
                sleepEndTime: '',
                showError: '',
                disableFuture: moment().format("YYYY-MM-DD"),
                disableFutureTime: moment().format("HH:mm"),
                MinTodayDate : moment(moment().subtract(1,'days')).format("YYYY-MM-DD"),
                MinYesDate : moment(moment().subtract(2,'days')).format("YYYY-MM-DD"),
            };
        },
        props:['from'],
        methods:{
            SaveSleepData(){
                const _that = this
                _that.submitted = true
                _that.showError = false
                _that.$validator.validate().then(valid => {
                    if (valid) {
                        let sDate = moment(_that.sleepStartDate).format('YYYY-MM-DD')
                        let sTime = _that.sleepStartTime
                        let eDate = moment(_that.sleepEndDate).format('YYYY-MM-DD')
                        let eTime = _that.sleepEndTime
                        let sleepStart = moment(`${sDate} ${sTime}`).format('YYYY-MM-DD HH:mm:ss')
                        let sleepEnd = ''
                        if(this.from != 'daily-task'){   
                            sleepEnd = moment(`${eDate} ${eTime}`).format('YYYY-MM-DD HH:mm:ss')
                        }else{
                            if(this.$parent.filter == 'today'){
                                sleepEnd = moment(`${this.disableFuture} ${eTime}`).format('YYYY-MM-DD HH:mm:ss')
                            }else{
                                sleepEnd = moment(`${moment(moment(this.disableFuture).subtract(1,'days')).format("YYYY-MM-DD")} ${eTime}`).format('YYYY-MM-DD HH:mm:ss')
                            }
                        }
                        let a = moment(sleepStart)
                        let b = moment(sleepEnd)
                        if(b.diff(a, 'minutes') > 0){
                            let input_json = {
                                'globalParams' : {
                                    'dateOfSleep': sDate,
                                    'totalMinutesAsleep': b.diff(a, 'minutes'),
                                    'startTime': sleepStart,
                                    'endTime': sleepEnd
                                },'localParams' : {'parameter' : _that}
                            }
                            // console.log(input_json)
                            if(this.from){
                                input_json.localParams.from = this.from
                            }
                            this._runAddSleepData(input_json)
                        }else{
                            _that.showError = true
                        }
                    }
                }); 
            },
            reset(){
                this.submitted = false
                this.date1 = ''
                this.time1 = ''
                this.date2 = ''
                this.time2 = ''
            }   
        },
        created(){
           this.pageName('Input Sleep Data')
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/website/user/forms/sleep-data.vue